import { FormField } from "@ui-kit/Form/FormField";
import { TextInput } from "@ui-kit/TextInput/TextInput";
import { Rule } from "antd/lib/form";
import { useTranslation } from "react-i18next";

interface AdminOtpFieldProps {
  name?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled: boolean;
}

export const AdminOtpField = ({
  name = "otp",
  label,
  placeholder,
  required = true,
  disabled,
}: AdminOtpFieldProps) => {
  const { t } = useTranslation();
  const rules: Rule[] = [
    ...(required
      ? [{ required: true, message: t("forms.adminOtpField.required") }]
      : []),
    {
      len: 6,
      message: t("forms.adminOtpField.length"),
    },
  ];

  return (
    <FormField label={label ?? t("forms.adminOtpField.label")} name={name}>
      <TextInput
        name={name}
        type="otp"
        placeholder={placeholder ?? t("forms.adminOtpField.placeholder")}
        size="large"
        rules={rules}
        disabled={disabled}
        autoComplete="one-time-code"
      />
    </FormField>
  );
};
